













































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { CallType } from '@/models/admin/calltype';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { getCallTypeHeaders } from '@/views/admin/calltype/callType';
import {callTypeService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
    computed: {
        // isValidate() {
        //     this.addDialog.action.disable = !this.name;
        // },
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
})
export default class CallTypeListPage extends Base {
    public headers: VHeaders[] = getCallTypeHeaders(this);
    public callTypes: CallType[] = [];
    public callType: CallType = {};
    public addDialog: IDialogOption = {
        width: 500,
        title: '',
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: this.$parent.$t('callTypes.btnSubmit') as string, disable: false },
        loading: false,
        onAction: (): void => {
            this.addOrUpdate();
        },
        onClose: (): void => {
            this.hideAddOrUpdateDialog();
        },
    };
    public pagination = new PaginationModel('name');
    public loading: boolean = false;
    public name: string = '';
    public description: string = '';
    public actions: any[] = [];
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('callTypes.deleteDialogTitle') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
        onAction: (): void => {
            this.deleteCallType();
        },
    };
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public callTypeToDelete: CallType = {};

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'addCallType') {
            this.showAddOrUpdateDialog(null);
        }

        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('callTypes.btnAddCallType'), disabled: false, visible: true, class: 'btn', label: this.$t('callTypes.btnAddCallType'), click: 'addCallType', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'callTypes');

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        this.setActions();
        this.getcallTypes();
    }

    public setActions() {
        this.actions = [{
            type: 'button',
            icon: 'fas fa-edit',
            title: this.$t('callTypes.callTypeGirdHeaders.gridAction.edit') as string,
            action: (model: CallType) => { this.showAddOrUpdateDialog(model); },
        },
        ];
    }

    public async getcallTypes(): Promise<void> {
        try {
            this.loading = true;
            const callTypes = await callTypeService.getCallTypesAsync();
            this.callTypes = callTypes.results;
            this.pagination.totalItems = callTypes.total;
        } finally {
            this.loading = false;
        }
    }

    public updatePaging(paging: PaginationModel) {
        this.pagination = paging;
    }

    public async addOrUpdate(): Promise<void> {
        if(this.validateForm()){ 
        if (this.callType) {
            this.callType.name = this.name;
            this.callType.description = this.description;
        }
        if (!this.name) {
            return;
        }
        if (!this.callType.id) {
            try {
                this.addDialog.loading = true;
                await callTypeService.addCallTypeAsync(this.callType);
                this.getcallTypes();
                this.showAlert(true, this.$t('callTypes.alertSaveCallType'));
            } finally {
                this.addDialog.loading = false;
                this.addDialog.model = false;
            }
        } else {
            try {
                this.addDialog.loading = true;
                await callTypeService.updateCallTypeAsync(this.callType);
                this.getcallTypes();
                this.showAlert(true, this.$t('callTypes.alertUpdateCallType'));
            } finally {
                this.addDialog.loading = false;
                this.addDialog.model = false;
            }
        }
        }
    }

    public confirmDelete(item: CallType): void {
        this.deleteDialog.model = true;
        this.callTypeToDelete = item;
    }

    public async deleteCallType(): Promise<void> {
        try {
            await callTypeService.deleteCallTypeAsync(this.callTypeToDelete.id);
            this.showAlert(true, this.$t('callTypes.alertDeleteCallType'));
            this.getcallTypes();
        } finally {
            this.deleteDialog.model = false;
        }
    }

    public showAddOrUpdateDialog(model: CallType): void {
        if (model) {
            this.callType = model;
            this.name = model.name;
            this.description = model.description;
            this.addDialog.title = this.$parent.$t('callTypes.editDialogTitle') as string;
        } else {
            this.callType = {};
            this.name = '';
            this.description = '';
            this.addDialog.title = this.$parent.$t('callTypes.addDialogTitle') as string;
        }
        this.$validator.reset();
        this.addDialog.model = true;
    }

    public hideAddOrUpdateDialog(): void {
        this.$validator.reset();
        this.addDialog.model = false;
    }
}
